module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-contract-last/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    时隔"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.yearDiff))]), _vm._v("之后"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.lastContractDate))]), _c('br'), _vm._v("\n    您再次选择了吉凯基因的 "), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.lastContractProduct))]), _c('br'), _c('br'), _vm._v("\n\n    您与吉凯的合作时长超过"), _c('span', {
    staticClass: "collaborationDurationProportion"
  }, [_vm._v(_vm._s(_vm.data.collaborationDurationProportion))]), _vm._v("用户"), _c('br'), _vm._v("被授予"), _c('span', {
    staticClass: "text-ke"
  }, [_vm._v("科研巨匠")]), _vm._v("称号"), _c('br')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-682eafec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageContractLast/index.vue
// module id = 1666
// module chunks = 8